import { NginxTrafficView } from '../../components/system-logs';

// Access is developer-only, enforced by the route gate in Dashboard.jsx
// and again by the /api/logs routes server-side.
export default function NginxTraffic() {
  return <NginxTrafficView />;
}
